<template>
  <div>
    <Loading v-if="loading" />
    <div v-else>
      <Alert v-if="isApproved" type="success">
        Equipe <b>Aprovada</b>, não pode ser alterada.
      </Alert>

      <div v-if="team.payableReceivable">
        <Alert type="info">
          <span>
            Conta vinculada, sua alteração resultará em uma modificação no <b>Financeiro</b>.
          </span>
        </Alert>
      </div>
      <b-row>
        <b-col sm="12">
          <Select title="Colaborador" field="collaboratorId" :formName="formName" :required="true"
            url="/api/v1/human-resources/collaborator/select-all" :disabled="isApproved" v-model="team.collaborator" />
        </b-col>
      </b-row>
      <TeamPeriodValue :team="team" :formName="formName" :disabled="isApproved" />
      <b-row>
        <b-col sm="12">
          <EditorHtml title="Descrição" :required="false" :maxLength="1000" :disabled="isApproved"
            v-model="team.description" />
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col sm="12">
          <div class="text-right">
            <Button _key="btnSaveTeamUpdate" type="success" title="Salvar"
              :disabled="!isFormValid(formName) || isApproved" classIcon="fas fa-save" size="medium"
              :clicked="save" />
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Select from "@/ui/forms/Select";
import EditorHtml from "@/ui/forms/EditorHtml";
import Button from "@/ui/forms/Button";
import Loading from "@/ui/shared/Loading.vue";
import Alert from "@/ui/layout/Alert";

import TeamPeriodValue from "./TeamPeriodValue.vue";

import Team from "../models/Team.js";
import TeamService from "../services/team.service";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "TeamUpdate",
  components: { Select, EditorHtml, Button, Loading, Alert, TeamPeriodValue },
  props: {
    cardId: {
      type: String,
      default: "",
    },
    rentId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      formName: "teamUpdate",
      loading: false,
      team: new Team(),
    };
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
    ...mapGetters("generic", ["event"]),
    genericId() {
      return this.cardId || this.rentId;
    },
    isApproved() {
      const status = (this.team && (this.team.statusName || this.team.StatusName)) || "";
      return String(status).toLowerCase() === "aprovada";
    },
  },
  methods: {
    ...mapMutations("generic", ["removeLoading", "addEvent"]),
    async getById(id) {
      this.loading = true;
      const response = await TeamService.getById(id);
      this.update(response.data.content);
      this.loading = false;
    },
    async save() {
      this.team.genericId = this.genericId;
      try {
        await TeamService.save(this.team);
        this.addEvent({ name: "reloadCardTeam" });
      } finally {
        this.removeLoading(["btnSaveTeamUpdate"]);
      }
    },
    update(data) {
      this.team = new Team();
      this.team.update(data);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "updateCardTeam") this.getById(event.data.id);
      },
      deep: true,
    },
  },
};
</script>
<style scoped></style>
